<div>
    <router-outlet
    >
    </router-outlet>
    <recent-keypress-view></recent-keypress-view>
</div>
